import { validationMixin } from 'vuelidate';
import { required, maxLength, email, requiredIf } from 'vuelidate/lib/validators';
import regions from '@/data.js';
export default {
    // components : {
        // CountrySelect,
        // RegionSelect
        // CountryRegionSelect
    // },
    mixins: [validationMixin],

    validations: {
        radiosAddressType   : { required },
        radiosAddressTitle  : { required },
        fieldCompany        : {
            maxLength: maxLength(100),
            required : requiredIf(function (model) {
                if (this.radiosAddressType = 'typeCompany') {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        fieldDepartment     : {
            maxLength: maxLength(100),
            required : requiredIf(function (model) {
                if (this.radiosAddressType = 'typeCompany') {
                    return false;
                } else {
                    return true;
                }
            }),

        },
        fieldFirstname      : { required, maxLength: maxLength(40) },
        fieldLastname       : { required, maxLength: maxLength(40) },
        fieldStreet         : { required, maxLength: maxLength(100) },
        fieldZipCode        : { required, maxLength: maxLength(4) },
        fieldCity           : { required, maxLength: maxLength(50) },
        selectCountry       : { required },
        selectLanguage      : { required },

        formAddress : [
            'radiosAddressType',
            'radiosAddressTitle',
            'fieldCompany',
            'fieldDepartment',
            'fieldFirstname',
            'fieldLastname',
            'fieldStreet',
            'fieldZipCode',
            'fieldCity',
            'selectCountry',
            'selectLanguage'
        ]
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data: () => ({
        formAddress         : null,

        radiosAddressType   : null,
        radiosAddressTitle  : null,
        fieldCompany        : null,
        fieldDepartment     : null,
        fieldFirstname      : null,
        fieldLastname       : null,
        fieldStreet         : null,
        selectCountry       : null,
        fieldZipCode        : null,
        fieldCity           : null,
        selectLanguage      : null,
        countries           : [
            {
                code  : "ch",
                label : {
                    de : "Schweiz",
                    en : "Switzerland",
                    fr : "Suisse",
                    it : "Svizzera"
                }
            },{
                code  : "fr",
                label : {
                    de : "Frankreich",
                    en : "France",
                    fr : "France",
                    it : "Francia"
                }
            },{
                code  : "it",
                label : {
                    de : "Italia",
                    en : "Italy",
                    fr : "Italie",
                    it : "Italia"
                }
            },{
                code  : "de",
                label : {
                    de : "Deutschland",
                    en : "Germany",
                    fr : "Allemagne",
                    it : "Germania"
                }
            },{
                code  : "at",
                label : {
                    de : "Österreich",
                    en : "Austria",
                    fr : "Autriche",
                    it : "Austria"
                }
            },{
                code  : "li",
                label : {
                    de : "Lichtenstein",
                    en : "Lichtenstein",
                    fr : "Lichtenstein",
                    it : "Lichtenstein"
                }
            },

        ],
        languages: [
            'Deutsch',
            'Französisch',
            'Italiano',
            'Englisch',
        ],
        checkbox: false,
    }),

    methods: {
        validateForm() {
            this.$v.formAddress.$touch();
            console.info('validate', this.$v.formAddress);
            console.info('any error', this.$v.formAddress.$anyError);
            if (this.$v.formAddress.$anyError) {
                return false;
            } else {
                return true;
            }
        },
        onValidateFields() {
            if (this.$v.formAddress.$dirty) {
                this.$v.formAddress.$touch();
            } else {
                return;
            }
        },
        resetForm() {
            console.warn('resetting....');
            if (this.$v.formAddress.$dirty) {
                this.$v.formAddress.$reset();
                this.radiosAddressType  = null;
                this.radiosAddressTitle = null;
                this.fieldCompany       = null;
                this.fieldDepartment    = null;
                this.fieldFirstname     = null;
                this.fieldLastname      = null;
                this.fieldStreet        = null;
                this.selectCountry      = null;
                this.fieldZipCode       = null;
                this.fieldCity          = null;
                this.selectLanguage     = null;
                this.$emit('form-address-is-valid');
            }
        },
        getFormValues() {
            let ret = {};

            ret.radiosAddressType   = this.radiosAddressType;
            ret.radiosAddressTitle  = this.radiosAddressTitle;
            ret.fieldCompany        = this.fieldCompany;
            ret.fieldDepartment     = this.fieldDepartment;
            ret.fieldFirstname      = this.fieldFirstname;
            ret.fieldLastname       = this.fieldLastname;
            ret.fieldStreet         = this.fieldStreet;
            ret.selectCountry       = this.selectCountry;
            ret.fieldZipCode        = this.fieldZipCode;
            ret.fieldCity           = this.fieldCity;
            ret.selectLanguage      = this.selectLanguage;

            return ret;
        },
        setFormValues(data) {
            console.info('data', data);
            this.radiosAddressType   = data.radiosAddressType;
            this.radiosAddressTitle  = data.radiosAddressTitle;
            this.fieldCompany        = data.fieldCompany;
            this.fieldDepartment     = data.fieldDepartment;
            this.fieldFirstname      = data.fieldFirstname;
            this.fieldLastname       = data.fieldLastname;
            this.fieldStreet         = data.fieldStreet;
            this.selectCountry       = data.selectCountry;
            this.fieldZipCode        = data.fieldZipCode;
            this.fieldCity           = data.fieldCity;
            this.selectLanguage      = data.selectLanguage;
        },
    },
    watch: {
        '$v.formAddress.$anyError' : function(errors) {
            if (errors) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('form-address-has-errors');
            } else {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-address-is-valid');

            }
        },
        '$v.formAddress.$dirty' : function(dirty) {
            if (!dirty && !this.$v.formAddress.$anyError) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-address-is-valid');
            } else {
                if (this.$v.formAddress.$anyError) {
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('form-address-has-errors');
                }
            }
        }
    },
    computed: {
        radiosAddressTypeErrors () {
            const errors = [];
            if (!this.$v.radiosAddressType.$dirty) {
                return errors;
            }
            if(!this.$v.radiosAddressType.required) {
                errors.push('radiosAddressType is required.');
            }
            return errors;
        },
        radiosAddressTitleErrors () {
            const errors = [];
            if (!this.$v.radiosAddressTitle.$dirty) {
                return errors;
            }
            if(!this.$v.radiosAddressTitle.required) {
                errors.push('radiosAddressTitle is required.');
            }
            return errors;
        },
        fieldCompanyErrors () {
            const errors = [];
            if (!this.$v.fieldCompany.$dirty) {
                return errors;
            }
            if(!this.$v.fieldCompany.maxLength) {
                errors.push('fieldCompany Name must be at most 100 characters long');
            }
            if(!this.$v.fieldCompany.required) {
                errors.push('fieldCompany is required.');
            }
            return errors;
        },
        fieldDepartmentErrors () {
            const errors = [];
            if (!this.$v.fieldDepartment.$dirty) {
                return errors;
            }
            if(!this.$v.fieldDepartment.maxLength) {
                errors.push('fieldDepartment Name must be at most 100 characters long');
            }
            if(!this.$v.fieldDepartment.required) {
                errors.push('fieldDepartment is required.');
            }
            return errors;
        },
        fieldFirstnameErrors () {
            const errors = [];
            if (!this.$v.fieldFirstname.$dirty) {
                return errors;
            }
            if(!this.$v.fieldFirstname.maxLength) {
                errors.push('fieldFirstname Name must be at most 100 characters long');
            }
            if(!this.$v.fieldFirstname.required) {
                errors.push('fieldFirstname is required.');
            }
            return errors;
        },
        fieldLastnameErrors () {
            const errors = [];
            if (!this.$v.fieldLastname.$dirty) {
                return errors;
            }
            if(!this.$v.fieldLastname.maxLength) {
                errors.push('fieldLastname Name must be at most 100 characters long');
            }
            if(!this.$v.fieldLastname.required) {
                errors.push('fieldLastname is required.');
            }
            return errors;
        },
        fieldStreetErrors () {
            const errors = [];
            if (!this.$v.fieldStreet.$dirty) {
                return errors;
            }
            if(!this.$v.fieldStreet.maxLength) {
                errors.push('fieldStreet Name must be at most 100 characters long');
            }
            if(!this.$v.fieldStreet.required) {
                errors.push('fieldStreet is required.');
            }
            return errors;
        },
        selectCountryErrors () {
            const errors = [];
            if (!this.$v.selectCountry.$dirty) {
                return errors;
            }
            if(!this.$v.selectCountry.required) {
                errors.push('selectCountry is required');
            }
            return errors;
        },
        fieldZipCodeErrors () {
            const errors = [];
            if (!this.$v.fieldZipCode.$dirty) {
                return errors;
            }
            if(!this.$v.fieldZipCode.maxLength) {
                errors.push('fieldZipCode must be at most 4 characters long');
            }
            if(!this.$v.fieldZipCode.required) {
                errors.push('fieldZipCode is required.');
            }
            return errors;
        },
        fieldCityErrors () {
            const errors = [];
            if (!this.$v.fieldCity.$dirty) {
                return errors;
            }
            if(!this.$v.fieldCity.maxLength) {
                errors.push('fieldCity must be at most 50 characters long');
            }
            if(!this.$v.fieldCity.required) {
                errors.push('fieldCity is required.');
            }
            return errors;
        },
        selectLanguageErrors () {
            const errors = [];
            if (!this.$v.selectLanguage.$dirty) {
                return errors;
            }
            if(!this.$v.selectLanguage.required) {
                errors.push('selectLanguage is required');
            }
            return errors;
        },
    }
};
